'use strict';

import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { TrackingConstants, fetchUpdatedFilterState, setOpenFilterName } from '../cfs-search-slice';

import analytics from '../../../../utils/analytics';

export const FilterSummaryItem = ({ filterItems, navigatedItem, filterName, label }) => {
	const dispatch = useDispatch();

	const isDisabled = !filterItems || filterItems.length === 0;
	const isSingleItem = filterItems?.length === 1;

	const isOpen = useSelector((state) => state.cfsSearch.openFilterName === filterName);

	const onOpen = (e) => {
		dispatch(setOpenFilterName(filterName));
	}

	const onItemDeselected = (e) => {
		analytics.trackEvent(TrackingConstants.Categories.Removed, filterName, TrackingConstants.Labels.Unset);

		dispatch(fetchUpdatedFilterState({
			name: filterName,
			value: ''
		}));
	};

	const renderSelected = () => {
		let filterClassName = 'search-filters__filter search-filters__filter--selected';
		let filterItem = navigatedItem;

		let deselectButton = (
			<button
				className="search-filters__filter__remove fi-icon fi-icon--large fi-icon--no-margin fi-x-circle"
				onClick={onItemDeselected} />
		);

		if (isSingleItem) {
			filterClassName += ' search-filters__filter--single';
			filterItem = filterItems[0];
			deselectButton = null;
		}

		return (
			<div>
				<span className={filterClassName}>
					{deselectButton}
					<span className="search-filters__filter__label">{label}:</span>
					<span className="search-filters__filter__value">
						<span className="search-filters__filter__value__text">{filterItem.displayText}</span>
					</span>
				</span>
			</div>
		);
	};

	const renderDisabled = () => {
		return (
			<div>
				<a className="search-filters__filter search-filters__filter--unselected search-filters__filter--disabled">
					<span className="search-filters__filter__label">{label}</span>
					<span className="search-filters__filter__value">
						<span className="search-filters__filter__value__text">Any</span>
					</span>
				</a>
			</div>
		);
	};

	const renderUnselected = () => {
		let filterClassName = 'search-filters__filter search-filters__filter--unselected';

		if (isOpen) {
			filterClassName += ' search-filters__filter--open'
		}

		return (
			<div>
				<a className={filterClassName} onClick={onOpen}>
					<span className="search-filters__filter__label">{label}</span>
					<span className="search-filters__filter__value" onClick={onOpen}>
						<span className="search-filters__filter__value__text">Any</span>
					</span>
				</a>
			</div>
		);
	};

	if (navigatedItem || isSingleItem) {
		return renderSelected();
	} else if (isDisabled) {
		return renderDisabled();
	} else {
		return renderUnselected();
	}
}